<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <ion-button (click)="navController.back()" fill="clear" shape="round">
        <ion-icon name="chevron-back" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ 'page.working_time.title' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="redirectToHandbook()" fill="clear" shape="round">
        <ion-icon name="information-circle-sharp" slot="start"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-input
    mode="ios"
    class="month-selector"
    type="month"
    [value]="dashboardContext.monthYear()"
    (ionChange)="onMonthInputChange($event)"
  ></ion-input>

  <ion-note>
    {{ 'page.working_time.last_updated' | translate }}:
    {{ lastUpdatedDateTime | localizedDateTimeFormat }}
  </ion-note>
</ion-header>

<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="onRefresh($event)">
    <ion-refresher-content> </ion-refresher-content>
  </ion-refresher>

  @if (!!showDashboardWorkingTimeSignal()) {
    <wilson-working-time-cards></wilson-working-time-cards>
  }

  @if (showDashboardOvertimeAndOtherAccountsSignal()) {
    <wilson-working-time-overtimes></wilson-working-time-overtimes>
  }
  @if (showDashboardPayPremiumsSignal()) {
    <wilson-working-time-bonuses></wilson-working-time-bonuses>
  }
  @if (showDashboardOtherSignal()) {
    <wilson-other-categories></wilson-other-categories>
  }
  @if (showDashboardTimesheetSignal()) {
    <wilson-working-time-pdf-timesheet></wilson-working-time-pdf-timesheet>
  }
</ion-content>
